import React from "react";
import { PlxsText, PlxsTextLink } from "@plexlogic/plexus-ui";

const ScrutineerRequirementText: React.FC = () => {
  return (
    <PlxsText>
      Prizes of this value may need an independent scrutineer to witness the
      draw and confirm it was run fairly. If yours does, they'll need to be
      present when it runs.{" "}
      <PlxsTextLink
        href="https://help.plexus.co/en/articles/3784317-draw-scrutineer-requirements"
        dataTestId="scrutineer-requirements-help-link"
        iconName="externalLink"
        target="_blank"
      >
        Check the requirements
      </PlxsTextLink>{" "}
      if you're unsure.
    </PlxsText>
  );
};

export default ScrutineerRequirementText;
